var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.firstConnection ? _c("div", [_c("profile", {
    attrs: {
      firstConnection: true,
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _c("div", {
    staticClass: "submenus"
  }, [_c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.profile
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.profile ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("My profile")])])]), _vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.orders
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.orders ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("My orders")])])]) : _vm._e(), _vm.isUserBuyerGroup(_vm.loggedUserData) || _vm.isConsultantNotHolding(_vm.loggedUserData) ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.creditNotes
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.creditNotes ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("My credits")])])]) : _vm._e(), _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.favorites
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.favorites ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("My favorites")])])]), _vm.IS_STRIPE_ENABLED && (_vm.isUserBuyerGroup(_vm.loggedUserData) || _vm.isConsultantOrHolding(_vm.loggedUserData) && _vm.hasRole("manageWallet")) ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.wallet
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.wallet ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("My wallet")])])]) : _vm._e()], 1), _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "container-centered small"
  }, [_vm.selectedTab === _vm.tabs.favorites ? _c("div", [_c("favorite", {
    attrs: {
      searchCriterias: _vm.searchCriterias,
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e(), _vm.selectedTab === _vm.tabs.orders ? _c("div", [_c("orders", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e(), _vm.selectedTab === _vm.tabs.creditNotes ? _c("div", [_c("creditNotes", {
    attrs: {
      searchCriterias: _vm.searchCriterias,
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e(), _vm.selectedTab === _vm.tabs.profile ? _c("div", [_c("profile", {
    attrs: {
      firstConnection: false,
      accountStatus: _vm.myStatus,
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e(), _vm.selectedTab === _vm.tabs.wallet ? _c("div", [_c("wallet", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e()])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };